// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-success_wrapper__pXn\\+m {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.change-password-success_container__i5\\+th {
  width: 100%;
  max-width: 511px;
  display: grid;
  grid-template-rows: repeat(3, min-content);
  gap: 32px;
}

.change-password-success_illustration-container__-8rQQ {
  display: flex;
  justify-content: center;
  align-items: center;
}

.change-password-success_illustration__FmVHd {
  width: 100%;
  max-width: 400px;
}

.change-password-success_content__kBJHC {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/password/change-password-success.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n}\n\n.container {\n  width: 100%;\n  max-width: 511px;\n  display: grid;\n  grid-template-rows: repeat(3, min-content);\n  gap: 32px;\n}\n\n.illustration-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.illustration {\n  width: 100%;\n  max-width: 400px;\n}\n\n.content {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `change-password-success_wrapper__pXn+m`,
	"container": `change-password-success_container__i5+th`,
	"illustration-container": `change-password-success_illustration-container__-8rQQ`,
	"illustration": `change-password-success_illustration__FmVHd`,
	"content": `change-password-success_content__kBJHC`
};
export default ___CSS_LOADER_EXPORT___;
